import { makeActionCreator } from "../utils/reduxUtils";
import API from "../utils/API";
import { AppState } from "..";

/**********************  SYNCHRONOUS ACTIONS ********************/

export const SET_LOGIN_FIELD = "SET_LOGIN_FIELD";
export const setLoginField = makeActionCreator(SET_LOGIN_FIELD, 'fieldName', 'fieldValue');

export const SET_SIX_DIGITS_2FA_PART1 = "SET_SIX_DIGITS_2FA_PART1";
export const setSixDigits2faPart1 = makeActionCreator(SET_SIX_DIGITS_2FA_PART1, "payload");
export const SET_SIX_DIGITS_2FA_PART2 = "SET_SIX_DIGITS_2FA_PART2";
export const setSixDigits2faPart2 = makeActionCreator(SET_SIX_DIGITS_2FA_PART2, "payload");
export const CLEAR_ERRORS = "CLEAR_ERRORS";
export const clearErrors = makeActionCreator(CLEAR_ERRORS, "payload");

export const VALIDATE_LOGIN_FIELDS = "VALIDATE_LOGIN_FIELDS";

export const LOGIN_USER_REQUEST = "LOGIN_USER_REQUEST";
export const LOGIN_USER_SUCCESS = "LOGIN_USER_SUCCESS";
export const LOGIN_USER_FAILURE = "LOGIN_USER_FAILURE";

export const SEND_LOGIN_CODE_VIA_SMS_REQUEST = "SEND_LOGIN_CODE_VIA_SMS_REQUEST";
export const SEND_LOGIN_CODE_VIA_SMS_SUCCESS = "SEND_LOGIN_CODE_VIA_SMS_SUCCESS";
export const SEND_LOGIN_CODE_VIA_SMS_FAILURE = "SEND_LOGIN_CODE_VIA_SMS_FAILURE";


/* Thunk to handle async operations */
export const loginUser = (email: string, password: string, code2fa?: string) => {
  return (dispatch: Function, getState: () => AppState) => {
    dispatch({ type: VALIDATE_LOGIN_FIELDS });
    const newState = getState();
    if (!Object.keys(newState.login.errors).length) {
      // no errors
      return dispatch({
        types: [LOGIN_USER_REQUEST, LOGIN_USER_SUCCESS, LOGIN_USER_FAILURE],
        callAPI: () => API.loginUser(email, password, code2fa)
      })
    }
  }
}


export const sendLoginCodeViaSMS = function (data: { email: string, password: string }) {
  return {
    types: [SEND_LOGIN_CODE_VIA_SMS_REQUEST, SEND_LOGIN_CODE_VIA_SMS_SUCCESS, SEND_LOGIN_CODE_VIA_SMS_FAILURE],
    callAPI: () => API.sendLoginCodeViaSMS(data)
  }
}